import Card, { CardProps } from '../Card'

const WeedgetCard: FC<CardProps> = (props) => {
  return <Card $p={0} $width={'100%'} $minHeight={280} $overflow={'hidden'} {...props} />
}

export default WeedgetCard
